import React, { useEffect, useState } from "react"

// Hooks
import { useGenreFetch } from "../../hooks/useGenreFetch"
// My Component
import { Page, Breadcrumb, ViewAll, Card, Spiner, Button } from "../../components"
import { useParams } from "react-router"
import GenreDB from "../../fixtures/genre.json"
import { IMAGE_BASE_URL, POSTER_SIZE } from "../../helpers/config"

function Genre() {
  const { id } = useParams()
  const [title, setTitle] = useState("...")
  const [movies, dispatch] = useGenreFetch(id)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    GenreDB.forEach((item) => {
      if (item.id === parseInt(id)) {
        setTitle(item.name)
      }
    })
  }, [id])

  function loadMore() {
    dispatch({ type: "loadMore" })
    setLoading(true)
  }

  useEffect(() => {
    setLoading(false)
  }, [movies])

  return (
    <Page title={`By ${title}`} disc={`Best of movies by ${title}`}>
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item to="/categories" title="Genre" />
          <Breadcrumb.Item title={title} />
        </Breadcrumb.List>
      </Breadcrumb>
      <ViewAll>
        <ViewAll.Title>Movies By {title}</ViewAll.Title>
        <ViewAll.Body>
          {movies &&
            movies.map((movie) => {
              return (
                <Card key={movie.id} to={`/movie/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : ""} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.title}</Card.Title>
                    <Card.Date>{movie.release_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}
        </ViewAll.Body>
        <ViewAll.More>{isLoading ? <Spiner /> : <Button.LoadMore onClick={loadMore}>Load More</Button.LoadMore>}</ViewAll.More>
      </ViewAll>
    </Page>
  )
}

export default Genre
